export const keyCryptoJS = "m@dr1sk1"